module.exports = __webpack_public_path__ + "static/media/RP-B_S_Timeless_Sforza_IndacoBlue.7b83f62f.png";